import React, { useState } from "react";
import {
  useEditProjectMutation
} from "../../../project/api/projectApiSlice";
import CategoryChangeLabelPresentation from "../../presentation/categorychagneLabelpresentation/category.changelabel.presentation";
import { CategoryChangeLabelContainerProp } from "../../types/types";
const CategoryChangeLabelContainer: React.FC<
CategoryChangeLabelContainerProp
> = ({ project }) => {
  const [editProject, 
    // { isLoading, isError, isSuccess }


  ] =
    useEditProjectMutation();

  const [categoryLabel, setCategoryLabel] = useState<string>(
    project?.categoryLabel
  )
  const onCategoryLabelHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCategoryLabel(e.target.value)
  }

  const editChagneCategoryLabelHandler = async () => {
    try {
      await editProject({
        _id: project._id,
        categoryLabel
      }).unwrap
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <div>
      <CategoryChangeLabelPresentation
        categoryLabel={categoryLabel}
        onChangeCategoryLabel={onCategoryLabelHandler}
        onEditChangeCategoryLabelHandler={editChagneCategoryLabelHandler}
      />
    </div>
  )
}

export default CategoryChangeLabelContainer
